import React from 'react'

export default function Footer() {
  return (
    <div className='footer'> <a href="https://www.marvel.com/" target="_blank">"Data provided by Marvel. © 2014 Marvel"</a></div>
  )
}
